/**
 * Created by hernanherreros on 2019-05-03
 */

import { Request } from 'fetchboi'

export const getCongress = Request.register({
  endpoint: '/congresses/:slug',
  method: 'get',
  useAuthentication: true,
})

export const updateCongress = Request.register({
  endpoint: '/congresses/:slug',
  method: 'put',
  useAuthentication: true,
})

export const getCongressStatus = Request.register({
  endpoint: '/registrations/configurations/:CongressSlug/status',
  method: 'get',
  useAuthentication: true,
})
